/**
 * KAISHEPS.COM — Theme JavaScript
 * Dark. Aggressive. Built to convert.
 */

(function () {
  'use strict';

  // =====================================================
  // UTILITIES
  // =====================================================

  function $(selector, parent) {
    return (parent || document).querySelector(selector);
  }

  function $$(selector, parent) {
    return Array.from((parent || document).querySelectorAll(selector));
  }

  function on(el, event, handler, opts) {
    if (el) el.addEventListener(event, handler, opts || false);
  }

  function debounce(fn, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  // =====================================================
  // HEADER SCROLL EFFECT
  // =====================================================

  function initHeaderScroll() {
    const header = $('#site-header');
    if (!header) return;

    const onScroll = debounce(function () {
      if (window.scrollY > 60) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }, 10);

    on(window, 'scroll', onScroll, { passive: true });
  }

  // =====================================================
  // MOBILE NAV TOGGLE
  // =====================================================

  function initMobileNav() {
    const toggle = $('#nav-toggle');
    const mobileNav = $('#mobile-nav');

    if (!toggle || !mobileNav) return;

    on(toggle, 'click', function () {
      const isOpen = mobileNav.classList.toggle('is-open');
      toggle.classList.toggle('is-active', isOpen);
      toggle.setAttribute('aria-expanded', isOpen.toString());
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });

    // Close on outside click
    on(document, 'click', function (e) {
      if (mobileNav.classList.contains('is-open')) {
        if (!toggle.contains(e.target) && !mobileNav.contains(e.target)) {
          mobileNav.classList.remove('is-open');
          toggle.classList.remove('is-active');
          toggle.setAttribute('aria-expanded', 'false');
          document.body.style.overflow = '';
        }
      }
    });

    // Close on nav link click
    $$('.mobile-nav-link').forEach(function (link) {
      on(link, 'click', function () {
        mobileNav.classList.remove('is-open');
        toggle.classList.remove('is-active');
        document.body.style.overflow = '';
      });
    });

    // Close on escape
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) {
        mobileNav.classList.remove('is-open');
        toggle.classList.remove('is-active');
        document.body.style.overflow = '';
      }
    });
  }

  // =====================================================
  // CART COUNT UPDATE
  // =====================================================

  function initCartCount() {
    const cartCount = $('#cart-count');
    if (!cartCount) return;

    // Fetch current cart count
    function updateCartCount() {
      fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          const count = cart.item_count;
          cartCount.textContent = count;
          if (count === 0) {
            cartCount.style.display = 'none';
          } else {
            cartCount.style.display = '';
          }
        })
        .catch(function () {
          // Silent fail — cart count just won't update
        });
    }

    // Listen for cart updates from form submissions
    document.addEventListener('submit', function (e) {
      const form = e.target;
      if (form && form.classList.contains('product-form')) {
        // Small delay to let Shopify process the cart add
        setTimeout(updateCartCount, 800);
      }
    });

    // Initial update
    updateCartCount();
  }

  // =====================================================
  // ADD TO CART HANDLING
  // =====================================================

  function initAddToCart() {
    const forms = $$('.product-form');

    forms.forEach(function (form) {
      on(form, 'submit', function (e) {
        e.preventDefault();

        const btn = form.querySelector('.add-to-cart-btn');
        if (!btn || btn.disabled) return;

        const formData = new FormData(form);

        // Loading state
        const originalText = btn.innerHTML;
        btn.innerHTML = '⌛ ADDING TO CART...';
        btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Cart add failed');
            return res.json();
          })
          .then(function () {
            btn.innerHTML = '✓ ADDED TO CART!';
            btn.style.background = '#22c55e';
            btn.style.borderColor = '#22c55e';

            // Update cart count
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                const cartCount = $('#cart-count');
                if (cartCount) {
                  cartCount.textContent = cart.item_count;
                  cartCount.style.display = cart.item_count > 0 ? '' : 'none';
                }
              });

            setTimeout(function () {
              btn.innerHTML = originalText;
              btn.disabled = false;
              btn.style.background = '';
              btn.style.borderColor = '';
            }, 2000);
          })
          .catch(function () {
            btn.innerHTML = '✗ ERROR — TRY AGAIN';
            btn.style.background = '#666';
            btn.style.borderColor = '#666';

            setTimeout(function () {
              btn.innerHTML = originalText;
              btn.disabled = false;
              btn.style.background = '';
              btn.style.borderColor = '';
            }, 2500);
          });
      });
    });
  }

  // =====================================================
  // SMOOTH SCROLL
  // =====================================================

  function initSmoothScroll() {
    $$('a[href^="#"]').forEach(function (anchor) {
      on(anchor, 'click', function (e) {
        const target = $(this.getAttribute('href'));
        if (!target) return;
        e.preventDefault();

        const headerHeight = 64 + 40; // header + announcement bar
        const top = target.getBoundingClientRect().top + window.scrollY - headerHeight;

        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  // =====================================================
  // PRODUCT PAGE — THUMBNAIL GALLERY
  // =====================================================

  function initProductGallery() {
    const mainImage = $('.product-image');
    const thumbnails = $$('.thumbnail');

    if (!mainImage || thumbnails.length === 0) return;

    thumbnails.forEach(function (thumb) {
      on(thumb, 'click', function () {
        const newSrc = thumb.getAttribute('data-src');
        if (!newSrc) return;

        // Fade transition
        mainImage.style.opacity = '0';
        mainImage.style.transition = 'opacity 0.2s ease';

        setTimeout(function () {
          mainImage.src = newSrc;
          mainImage.style.opacity = '1';
        }, 200);

        // Update active state
        thumbnails.forEach(function (t) { t.classList.remove('thumbnail--active'); });
        thumb.classList.add('thumbnail--active');
      });
    });
  }

  // =====================================================
  // VARIANT SELECTOR
  // =====================================================

  function initVariantSelector() {
    const variantBtns = $$('.variant-btn');
    const hiddenInput = $('input[name="id"]');

    if (variantBtns.length === 0 || !hiddenInput) return;

    // We need the product JSON for variant mapping
    const productJsonEl = $('#product-json');
    if (!productJsonEl) return;

    let productData;
    try {
      productData = JSON.parse(productJsonEl.textContent);
    } catch (e) {
      return;
    }

    const selectedOptions = {};

    variantBtns.forEach(function (btn) {
      on(btn, 'click', function () {
        const optionName = btn.getAttribute('data-option-name');
        const optionValue = btn.getAttribute('data-option-value');

        // Update selected state for this option group
        $$('.variant-btn[data-option-name="' + optionName + '"]').forEach(function (b) {
          b.classList.remove('variant-btn--active');
        });
        btn.classList.add('variant-btn--active');

        selectedOptions[optionName] = optionValue;

        // Find matching variant
        const matchingVariant = productData.variants.find(function (v) {
          return Object.keys(selectedOptions).every(function (key, idx) {
            return v['option' + (idx + 1)] === selectedOptions[key];
          });
        });

        if (matchingVariant) {
          hiddenInput.value = matchingVariant.id;

          // Update price
          const priceEl = $('.product-price');
          if (priceEl && matchingVariant.price) {
            const price = (matchingVariant.price / 100).toFixed(2);
            priceEl.textContent = '£' + price;
          }

          // Update add to cart button
          const addBtn = $('.add-to-cart-btn');
          if (addBtn) {
            if (matchingVariant.available) {
              const price = (matchingVariant.price / 100).toFixed(2);
              addBtn.innerHTML = '⚡ ADD TO CART — £' + price;
              addBtn.disabled = false;
            } else {
              addBtn.innerHTML = 'SOLD OUT';
              addBtn.disabled = true;
            }
          }
        }
      });
    });
  }

  // =====================================================
  // ANNOUNCEMENT BAR — PAUSE ON HOVER
  // =====================================================

  function initAnnouncementBar() {
    const bar = $('.announcement-bar');
    if (!bar) return;

    on(bar, 'mouseenter', function () {
      const text = $('.announcement-text');
      if (text) text.style.animationPlayState = 'paused';
    });

    on(bar, 'mouseleave', function () {
      const text = $('.announcement-text');
      if (text) text.style.animationPlayState = 'running';
    });
  }

  // =====================================================
  // SCROLL ANIMATIONS
  // =====================================================

  function initScrollAnimations() {
    const animatable = $$('[data-animate], .plan-card, .why-card, .testimonial-card');

    if (!animatable.length || !window.IntersectionObserver) return;

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -60px 0px' }
    );

    animatable.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px)';
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      observer.observe(el);
    });

    document.addEventListener('is-visible', function (e) {
      // handled above
    });

    // Use a style injection for the is-visible class
    const style = document.createElement('style');
    style.textContent = '.is-visible { opacity: 1 !important; transform: translateY(0) !important; }';
    document.head.appendChild(style);
  }

  // =====================================================
  // PROOF BAR — PAUSE ON HOVER
  // =====================================================

  function initProofBar() {
    const track = $('.proof-items');
    if (!track) return;

    on(track.parentElement, 'mouseenter', function () {
      track.style.animationPlayState = 'paused';
    });

    on(track.parentElement, 'mouseleave', function () {
      track.style.animationPlayState = 'running';
    });
  }

  // =====================================================
  // CART PAGE QUANTITY & REMOVE
  // =====================================================

  function initCartPage() {
    const cartItemsContainer = $('.cart-items');
    if (!cartItemsContainer) return;

    // Remove item buttons
    $$('.cart-item-remove').forEach(function (btn) {
      on(btn, 'click', function () {
        const key = btn.getAttribute('data-key');
        if (!key) return;

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 }),
        })
          .then(function () {
            window.location.reload();
          })
          .catch(function () {
            console.error('Could not remove item');
          });
      });
    });
  }

  // =====================================================
  // INIT ALL
  // =====================================================

  function init() {
    initHeaderScroll();
    initMobileNav();
    initCartCount();
    initAddToCart();
    initSmoothScroll();
    initProductGallery();
    initVariantSelector();
    initAnnouncementBar();
    initProofBar();
    initScrollAnimations();
    initCartPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
